import { BCMSDate, BrandingStyle } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";
import "./mobile.css";

/**
 * @function EDEStatementsEnrollmentPageFooterView
 * @returns {React.Component}
 * @example
 * <EDEStatementsEnrollmentPageFooterView text="FDIC Insured | Copyright 20XX">
 *  <p>This is inside the page footer.</p>
 * </EDEStatementsEnrollmentPageFooterView>
 */
export default function EDEStatementsEnrollmentPageFooterView(props) {
    const copyrightYear = BCMSDate.init().format("Y");
    const copyrightMessage = `Copyright ©${ copyrightYear } Beavercreek Marketing. All Rights Reserved.`;
  
    return (
      <BrandingStyle style={ undefined } className="ede-statements-enrollment-page-footer-view text-center flex-container flex-vertical">
  
          <div className="flex-container flex-horizontal all-center link-container">
            
          </div>
          <BrandingStyle style={ undefined } className="flex-height flex-container flex-horizontal all-center text-container">
            <div className="flex-container flex-horizontal align-center">{ copyrightMessage }</div>
          </BrandingStyle>
      </BrandingStyle>
    );
}